<template>
    <div :class="hasChild != null ? 'main' : 'main right-big1'">
        <!--头部-->
        <Head></Head>

        <!--右侧内容区域-->
        <RightContent></RightContent>
    </div>
</template>

<script>
    import Head from '@/views/layout2/Head.vue';
    import RightContent from '@/views/layout2/RightContent.vue';
    import store from '@/store/';
    import {delCookie} from '@/utils/base.js';

    export default {
        components: {
            // 头部
            Head,
            /*右边内容容器*/
            RightContent
        },
        data() {
            return {
                /*是否有子菜单*/
                hasChild: null,
                /*系统基本数据*/
                baseInfo: {
                    shop_logo: '',
                    shop_name: '',
                    user: {},
                    version: ''
                }
            };
        },
        provide: function () {
            return {
                baseInfo: this.baseInfo
            };
        },
        created() {
            this.getBaseInof();
        },
        methods: {
            /*左边子组件传来的参数*/
            selectMenuFunc(param) {
                this.hasChild = param;
            },

            async getBaseInof() {
                let res = await store.dispatch('common/getBaseInfo');
                this.baseInfo.shop_logo = res.logo;
                this.baseInfo.shop_name = res.shop_name;
                this.baseInfo.version = res.version;
                this.baseInfo.user = res.user;
            }
        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/layout2/main.vue